export default "__VITE_ASSET__f3446d05__"